import React from "react"
import { useTranslation } from "react-i18next"

import { RoomAirVolumeInput } from "./RoomAirVolumeInput"

export interface RoomRecirculatedAirInputProps {
  hideLabel?: boolean
  autoFocus?: boolean
}

export const RoomRecirculatedAirInput = React.memo(
  ({ hideLabel, autoFocus }: RoomRecirculatedAirInputProps) => {
    const { t } = useTranslation()
    return (
      <RoomAirVolumeInput
        name="room.rca"
        className="room-form__recirculated-air"
        label={t("Room.rca")}
        unit="m³/h"
        color="#f49f33"
        hideLabel={hideLabel}
        autoFocus={autoFocus}
        testId="room__recirculated-air__input"
      />
    )
  }
)
